import React from "react";
import { inject, observer } from "mobx-react";
import { AlertHolder } from "best-common-react";
import PropTypes from "prop-types";

const PiaAlerts = ({ rootStore: { alertStore } }) => (
  <div id="pia-alerts">
    <AlertHolder fullWidth={false} alerts={alertStore.alerts} onRemove={alertStore.removeAlert} />
  </div>
);

PiaAlerts.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(PiaAlerts));
